
import GroupList from './GroupList';

export default GroupList;
